module.exports = __webpack_public_path__ + "static/media/modal-1.2cba9898.jpg";